import type { IconData } from '@stacksjs/iconify-core'

export const oneFingerTapFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M21.24 8.596a11.2 11.2 0 0 0-2.942.021c-2.083.297-3.42 2.103-3.539 4.11c-.128 2.152-.257 5.614-.26 10.842l-2.7 2.523c-1.457 1.364-2.253 3.346-1.931 5.356c.666 4.151 1.818 7.17 2.879 9.23c1.338 2.6 3.953 4.065 6.776 4.428c3.876.5 7.8.513 11.68.074c3.28-.37 5.998-2.616 7.022-5.749a48 48 0 0 0 1.946-8.37c.264-1.937-.258-3.514-1.28-4.782c-1.01-1.252-2.485-2.182-4.102-2.896c-2.67-1.18-5.864-1.826-8.276-2.313q-.524-.105-.993-.203c-.035-2.064-.315-5.512-.54-8.005c-.186-2.062-1.563-3.983-3.74-4.266\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M20 5a9 9 0 0 0-9 9a2 2 0 1 1-4 0C7 6.82 12.82 1 20 1s13 5.82 13 13a2 2 0 1 1-4 0a9 9 0 0 0-9-9\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default oneFingerTapFlat
